import { useParams, useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { supportedLanguages, type SupportedLanguage } from '../../i18n'

export default function LanguageSwitcher() {
  const { lang } = useParams<{ lang: string }>()
  const location = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const switchLanguage = (newLang: SupportedLanguage) => {
    if (newLang === lang) return
    // Strip any leading /{lang} prefix using the canonical list so the result
    // is correct even when `lang` param is stale/undefined (e.g. during hydration).
    const langPattern = supportedLanguages.join('|')
    const pathWithoutLang = location.pathname.replace(
      new RegExp(`^/(${langPattern})(?=/|$)`), '',
    ) || '/'
    navigate(`/${newLang}${pathWithoutLang}${location.search}`)
  }

  return (
    <div className="flex items-center gap-1 text-sm">
      {supportedLanguages.map((code) => (
        <button
          key={code}
          onClick={() => switchLanguage(code)}
          className={`px-2 py-1 rounded transition-colors ${
            code === lang
              ? 'text-neutral-900 font-semibold'
              : 'text-neutral-600 hover:text-neutral-900'
          }`}
          aria-label={t(`language.${code}`)}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  )
}
